/**
 * @name: user
 * @description:
 * @author: qq2575896094
 * @time: 2024/4/9
 */

const prefix = '/onlinecs/manage/customer'

export default {
    getUserList: `${prefix}/queryCustomerListByCondition`,
    getTerminal: `${prefix}/getTerminal`,
    getMemberLevelList: `${prefix}/queryMemberLevelList`,
    getUserShopCodeList: `${prefix}/queryUserShopCodeListForCondition`,
    getUserDetail: '/onlinecs/service/customer/getCustomerInfoByUserCode',
    getReceiveAddress: `${prefix}/queryCustomerReceivingAddressList`
    // getMemberBonusFlow: '/service-zuul/user/getMemberBonusFlow',
    // getLoginLogList: '/service-zuul/user/pagingSelectUserDetailLoginLogList'
}
